export function Footer() {
	return (
		<div className="w-full pt-10 flex flex-col justify-start items-start">
			{/* Main Footer Content */}
			<div className="self-stretch h-auto flex flex-col justify-center items-center py-12 px-4">
				{/* Brand Section - Centered */}
				<div className="flex flex-col justify-center items-center gap-4">
					<div className="text-center text-[#49423D] text-2xl font-semibold leading-6 font-sans">
						Koach
					</div>
					<div className="text-center text-[rgba(73,66,61,0.90)] text-sm font-medium leading-[18px] font-sans">
						your running buddy who always knows
					</div>
					<div className="text-center text-[rgba(73,66,61,0.70)] text-xs font-normal leading-4 font-sans mt-2">
						Made with ❤️ for runners
					</div>
					<div className="text-center text-[rgba(73,66,61,0.65)] text-xs font-normal leading-4 font-sans mt-3">
						<a
							href="/privacy-policy"
							className="hover:text-[#37322F] transition-colors underline"
						>
							Privacy Policy
						</a>
					</div>
				</div>
			</div>

			{/* Bottom Section with Pattern */}
			<div className="self-stretch h-12 relative overflow-hidden border-t border-b border-[rgba(55,50,47,0.12)]">
				<div className="absolute inset-0 w-full h-full overflow-hidden">
					<div className="w-full h-full relative">
						{Array.from({ length: 400 }).map((_, i) => (
							<div
								key={`pattern-line-${i}`}
								className="absolute w-[300px] h-16 border border-[rgba(3,7,18,0.08)]"
								style={{
									left: `${i * 300 - 600}px`,
									top: "-120px",
									transform: "rotate(-45deg)",
									transformOrigin: "top left",
								}}
							/>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
